import styled from 'styled-components';
import { g200 } from '@shipae/components-sandbox/component/colors';

export const Highlight = styled.span`
  background-color: ${ g200() };
`;
